<template>
  <div id="hyvor-talk-view" ref="hyvorTalk"></div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import * as firebase from 'firebase'
export default {
  props: ["id"],
  computed: {
    ...mapState(['user']),
    getId() {
      
    }
  },
  created () {
    window.HYVOR_TALK_WEBSITE = Number(process.env.HYVOR_TALK_WEBSITE)
  },
  mounted () {
    window.hyvor_talk = null
    this.init()
  },
  watch: {
    'user.uid': function () {
      if (window.hyvor_talk) {
        this.init()
      }
    }
  },
  methods: {
    ...mapActions(['setupUserData']),
    async init () {
      if (!this.user || !this.user['uid']) return this.setupReadOnly()
      if (!this.user.sso) {
        const createSSO = firebase.functions().httpsCallable('user_onCallSetupSSO')
        await createSSO()
        await this.setupUserData(firebase.auth().currentUser)
      }
      this.setup()
    },
    setup () {
      window.HYVOR_TALK_CONFIG = {
        id: this.id,
        sso: {
          hash: `${this.user.sso.hash}`,
          userData: `${this.user.sso.userData}`,
          loginURL: "/LoginSignupPage"
        }
      };
      if (window.hyvor_talk) {
        return this.destroyElement()
        // return window.hyvor_talk.reload(window.HYVOR_TALK_CONFIG)
      }
      this.renderScripts()
    },
    setupReadOnly () {
      window.HYVOR_TALK_CONFIG = {
        id: this.id,
        sso: {
          userData: "e30=",
          hash: process.env.HYVOR_TALK_GUEST_HASH,
          loginURL: `${location.origin}/LoginSignupPage`
        }
      };


      if (window.hyvor_talk) {
        return window.hyvor_talk.reload(window.HYVOR_TALK_CONFIG)
      }

      this.renderScripts()
    },
    renderScripts () {
      var script = document.createElement('script');
      script.src = '//talk.hyvor.com/web-api/embed';
      document.head.appendChild(script)
    },
    destroyElement () {
      window.hyvor_talk = null
      this.init()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HyvorComments.vue